import {defaultContacts} from "./state";
import moment from 'moment';

export function setBranchOffices(state, branchOffices){
    state.branchOffices = branchOffices;
}
export function setVouchersTypes(state, vouchertype) {
    state.voucherTypes = vouchertype
}
export function setGroups (state, groups){
    state.groups = groups
  }
export function setContacts (state, contacts){
    state.contacts = contacts
}
export function setContactsdt (state, contactsdt){
    state.contactsdt = contactsdt
}
export function setContactdt(state, contactsdt) {
    state.contactdt = contactsdt
    state.contactsdt.push(contactsdt)
}

export function setContacts_filterdt(state, contactsdt) {
    let dt = state.params.document_transactions.find(el => el.order == state.order_account_select)
    dt.contact_select = contactsdt
}

export function setTemplates(state , templates) {
    state.templates = templates
}
export function setcost_center_1 (state, cost_center_1){
    state.cost_center_1 = cost_center_1
}
export function setCities(state, cities) {
    state.cities = cities
}
export function setSellers(state, sellers) {
    state.sellers = sellers
}
export function setProjects(state, projects) {
    state.projects = projects
}
export function setProjectsdt(state, projects) {
    state.projectsdt = projects
}
export function setConsecutive(state, consecutive) {
    let consecutive_number = consecutive.consecutive_number+1
    state.params.num_doc = consecutive_number.toString()
    state.params.prefix = consecutive.prefix
    state.code_voucherType = consecutive.code_voucher_type

    if (state.origin_document){
        state.params.affects_prefix_document = consecutive.prefix
        state.params.affects_number_document = consecutive_number.toString()
    }
}
export function setselected_document(state, selected_document){
    state.selected_document = selected_document
}
export function setbranchOffice(state, branchOffice){
    state.branchOffice= branchOffice
}

export function setprojects_column_visible(state, projects_column_visible){
    state.projects_column_visible = projects_column_visible
}
export function setcontact_column_visible (state, contact_column_visible){
    state.contact_column_visible = contact_column_visible
}
export function setcost_center_column_visible (state, cost_center_column_visible){
    state.cost_center_column_visible = cost_center_column_visible
}
export function setpayment_column_visible (state, payment_column_visible){
    state.payment_column_visible = payment_column_visible
}
export function setmanage_bank_document (state, manage_bank_document){
    state.manage_bank_document = manage_bank_document
}
export function setcross_date_visible (state, cross_date_visible){
    state.cross_date_visible = cross_date_visible
}
export function setmanage_document(state, manage_document) {
    state.manage_document = manage_document
}
export function setcommissionable_concept(state, commissionable_concept) {
    state.commissionable_concept = commissionable_concept
}
export function setcommissionable_concepts(state, commissionable_concepts){
    state.commissionable_concepts = commissionable_concepts
}
export function setaccount_selects(state, account_selects){
    // state.account_selects = account_selects
    // state.account_selects = []
    let data =[]
    account_selects.map((item)=>{
        if (item.level == 24575) {
            data.push(item)
        }
    })

    state.params.document_transactions.map((item)=>{
        if (item.order == state.order_account_select) {
            item.account_select = data
        }
    })
}

export function settotal_debit(state, total_debit){
    state.total_debit = total_debit
}
export function settotal_credit(state, total_credit){
    state.total_credit = total_credit
}
export function setParamsdocumentid(state, document_transaction) {
    state.params.document_id = state.params.document_id == null ? document_transaction.document_id : state.params.document_id

    state.selected_document_title = {
        id:document_transaction.document.id,
    }

    let index = state.params.document_transactions.findIndex( element => element.order == state.params.document_transaction.order)
    state.params.document_transactions[index].id_document_transactions = state.params.document_transactions[index].id_document_transactions == null ? document_transaction.id : state.params.document_transactions[index].id_document_transactions

    state.params.document_transactions.map((item)=>{
        if (!item.manage_document && !item.affects_document_id) {
            item.affects_document_id = state.params.document_id
        }
    })
}
export function setParamsdocument_id(state, document_id){
    state.params.document_id = document_id
}
export function setOrderForAccountSelectToChange(state, order) {
    state.order_account_select = order
}
export function setshowInputs(state, model_id){
    let model = state.templates.find(el => el.id == model_id)
    if (model) {
        state.showInputs.center_cost = model.select_cost_center == 1 || model.select_cost_center == 9 ? true : false
        /*state.showInputs.seller = model.see_seller*/
        state.showInputs.observation1 = model.observation_tittle_1  != null ? true : false
        state.showInputs.observation2 = model.observation_tittle_2 != null ? true : false
        state.showInputs.projects = model.projects == 1 || model.projects == 1 ? true : false
        state.showInputs.cross_doc = model.doc_cruce_management == 1 || model.doc_cruce_management == 9 ? true : false
        state.showInputs.cross_doc_date = model.crossing_document_dates == 1 || model.crossing_document_dates == 9 ? true : false
        state.showInputs.files = model.attach_file
        state.cross_title = model.doc_cruce_management == 1 || model.doc_cruce_management == 9 ? model.tittle : null
        state.validations_model.cross_doc = model.doc_cruce_management
        state.validations_model.cross_doc_date = model.crossing_document_dates
    }
}
export function setaccountselect(state, account_select){
    state.account_select = account_select
}
export function setpayment_methods(state, payment_methods){
    state.payment_methods = payment_methods
}
export function setmodel_code(state , model_code){
    state.model_code = model_code
}
export function setmodel_accounting_generate(state , model_accounting_generate){
    state.model_accounting_generate = model_accounting_generate
}
export function setShowPdf(state, show_pdf){
    state.file_name = show_pdf.accounting_link
    state.show_pdf = true
}
export function setloading_form(state, loading_form){
    state.loading_form = loading_form
}
export function setloading(state, loading){
    state.loading= loading
}
export function setloading_create_transaction(state, loading_create_transaction){
    state.loading_create_transaction = loading_create_transaction
}
export function setloading_cancel_accounting_document(state, loading_cancel_accounting_document){
    state.loading_cancel_accounting_document = loading_cancel_accounting_document
}
export function setorigin_document(state, origin_document){
    state.origin_document = origin_document
}
export function listTransactions(state, transactions){
    state.params.document_transactions = []
    let doc = state.params;
    transactions.map((el, index) =>{
        state.params.document_transactions.push({
            //datos que se muestran en la grilla
            account_code                :   el.account.code,
            account_name                :   el.account.name,
            order 						: 	el.order ? el.order : index,
            payment_method              :   null,
            account_id 					:	el.account_id,
            observation 				:	el.observations,
            contact_id 					: 	el.contact_id,
            projects_id                 :   el.projects_id,
            value 						:	el.operation_value,
            debit_credit                :   el.transactions_type,
            base_value 					: 	el.base_value,
            bank_document_number        :   el.bank_document_number,
            commissionable_concept_id   :   el.commissionable_concept_id,
            due_date                    :   el.due_date,
            quota_number                :   el.quota_number,
            center_cost                 :   el.cost_center_1,

            //datos para mostrar u ocultar columnas
            contact_column_visible 		: 	el.account.manage_contact_balances || el.account.capture_contact,
            projects_column_visible 	: 	el.account.manage_projects != 0,
            payment_column_visible 		: 	el.manage_way_to_pay,
            cost_center_column_visible 	: 	el.account.cost_center_1 || el.account.cost_center_2 || el.account.cost_center_3,
            base_value_column_visible 	: 	el.manage_base_value,
            commissionable_concept      :   el.account.commissionable_concept,
            manage_document             :   doc.vouchertype && doc.vouchertype.origin_document ? el.account && (el.account.manage_document_balances || el.capture_document || el.manage_contact_balance) && el.affects_document_id != el.document_id && (state.edit_document || state.Watch_documument) : false,

            //datos para cargar los selects
            account_select 				:	[el.account],
            contact_select 				: 	[el.contact],

            //ids para grilla y para manejo en back(crear o actualizar)
            id_document_transactions    :   el.id,
            id                          :   index,

            // verificar
            affects_document_id 		: 	el.affects_document_id,
            documet_id 					: 	el.document_number,
            no_doc 						:   el.affects_document && el.affects_document.prefix?el.affects_document.prefix.trim().length > 0?el.affects_document.prefix+'-'+el.affects_document.consecutive:el.affects_document.consecutive:null,
            affects_prefix_document     :   el.affects_prefix_document,
            crossing_number             :   el.crossing_consecutive,
            crossing_date               :   el.crossing_due_date_document,

            mode                        :   el.affects_document_id === el.document_id ? 1 : 2,
            affects_prefix              :   el.affects_prefix,
            affects_consecutive         :   el.affects_consecutive,
        })
    })
}
export function setloading_transactions(state, loading_transactions){
    state.loading_transactions = loading_transactions;
}

export function setParamsEdit(state, doc){
    state.edit_document = true;
    state.loading_totals = true
    state.params.user                           = doc.user
    state.params.user_accounting_modification   = doc.user_accounting_modification
    state.params.user_cancellation              = doc.user_cancellation
    state.params.cancellation_date              = doc.cancellation_date
    state.params.cancellation_reason_param      = doc.cancellation_reason_param
    state.params.document_date                  = doc.document_date
    state.params.ref_update_doc                 = doc.ref_update_doc
    state.params.created_at                     = doc.created_at
    state.params.accounting_date_last_modification= doc.accounting_date_last_modification
    state.selected_document_title.id            = doc.id
    state.selected_document_title.in_progress   = doc.in_progress
    state.params.branchoffice_id                = doc.branchoffice_id
    state.params.voucherType_id                 = doc.vouchertype_id
    state.params.num_doc                        = doc.consecutive.toString()
    state.params.prefix                         = doc.prefix
    state.params.date                           = doc.document_date
    state.params.template_id                    = doc.model_id
    state.params.contact_id                     = doc.contact_id
    state.params.document_id                    = doc.id
    state.params.observation                    = doc.observation
    state.params.observation2                   = doc.observation_two
    state.params.city_id                        = doc.city
    state.params.seller_id                      = doc.seller_id
    state.params.id_correria                    = doc.id_correria
    state.sellers                               = [doc.seller]
    state.params.affects_prefix_document        = doc.affects_prefix_document
    state.params.affects_number_document        = doc.affects_number_document
    state.params.affects_date_document          = doc.affects_date_document
    state.params.due_date                       = doc.due_date
    state.params.term_days                      = doc.term_days
    state.params.files                          = doc.files
    state.params.original_document              = doc.original_document
    state.params.check_info                     = doc.check_info

    state.params.documents_products = doc.documents_products;

    state.params.document_transactions = []

    doc.accounting_transactions.map((el, index) =>{
        const mode = el.affects_document_id === doc.id ? 1 : 2
        state.params.document_transactions.push({
            //datos que se muetran en la grilla
            order 						: 	index,
            payment_method              :   null,
            account_id 					:	el.account_id,
            observation 				:	el.observations,
            contact_id 					: 	el.contact_id,
            projects_id                 :   el.projects_id,
            value 						:	el.operation_value,
            debit_credit                :   el.transactions_type,
            base_value 					: 	el.base_value == null ? 0 : el.base_value,
            bank_document_number        :   el.bank_document_number,
            commissionable_concept_id   :   el.commissionable_concept_id,
            due_date                    :   el.due_date,
            quota_number                :   el.quota_number,
            center_cost                 :   el.cost_center_1,

            //datos para mostrar u ocultar columnas
            projects_column_visible 	: 	el.account && el.account.manage_projects != 0 ? true : false,
            payment_column_visible 		: 	el.manage_way_to_pay,
            contact_column_visible 		: 	el.account && el.account.manage_contact_balances,
            cost_center_column_visible 	: 	(el.account && el.account.cost_center_1) || (el.account && el.account.cost_center_2) || (el.account && el.account.cost_center_3) ? true : false,
            base_value_column_visible 	: 	el.manage_base_value,
            commissionable_concept      :   el.account && el.account.commissionable_concept,
            manage_document             :   doc.vouchertype && doc.vouchertype.origin_document ? el.account && el.account.manage_document_balances && el.affects_document_id != el.document_id && (state.edit_document || state.Watch_documument) : false,
            by_origin_document          :   el.account && el.account.manage_document_balances && el.affects_document_id != el.document_id && (state.edit_document || state.Watch_documument) && doc.vouchertype && doc.vouchertype.origin_document,

            //datos para cargar los selects
            account_select 				:	el.account ? [el.account] : [],
            contact_select 				: 	[el.contact],
            account_code                :   el.account != null ? el.account.code : null,
            account_name                :   el.account != null ? el.account.name : null,

            //ids para grilla y para manejo en back(crear o actualizar)
            id_document_transactions    :   el.id,
            id                          :   index,

            // verificar
            affects_document_id         :   el.affects_document_id,
            documet_id 					: 	el.document_number,
            no_doc 						:   el.affects_document ? (el.affects_prefix != null ? el.affects_prefix +' - '+ el.affects_consecutive : el.affects_consecutive) : null,
            affects_prefix_document     :   el.affects_prefix_document,
            crossing_number             :   el.crossing_consecutive,
            crossing_date               :   el.crossing_due_date_document,
            mode                        :   mode,
            affects_prefix              :   el.affects_prefix,
            affects_consecutive         :   el.affects_consecutive
        })
    })

    state.totals = {
        // Totales de los productos informativo
        total_quantity   : doc.total_quantity,
        total_discount   : doc.total_discount,
        total_vr_brut    : doc.total_vr_brut,
        total_vr_iva     : doc.total_vr_iva,
        total_           : doc.total_,
        total_items      : doc.total_items,
        total_inventory_cost_value : doc.total_inventory_cost_value,

        //totales documento
        total_value_brut : doc.total_value_brut,
        ret_fue_total    : doc.ret_fue_total,
        ret_iva_total    : doc.ret_iva_total,
        ret_ica_total    : doc.ret_ica_total,
        total_value      : doc.total_value
    }
    state.templates = state.params.template_id == null ? [] : state.templates
    state.sellers = state.params.seller_id == null ? [] : state.sellers

    state.loading_totals = false
}

export function setParamsClone(state, doc) {

    let due_date = moment().format('YYYY-MM-DD');

    const contact = state.contacts.find(c => c.id === doc.contact_id);

    if (contact && contact.pay_days) {
        due_date = moment().add(contact.pay_days, 'days').format('YYYY-MM-DD');
    }

    state.loading_totals = true;
    state.edit_document = true;
    state.params.document_date = doc.document_date;
    state.params.ref_update_doc = doc.ref_update_doc;
    state.params.created_at = doc.created_at;
    state.params.accounting_date_last_modification = doc.accounting_date_last_modification;
    state.selected_document_title.id = doc.id;
    state.selected_document_title.in_progress = true;
    state.params.branchoffice_id = doc.branchoffice_id;
    state.params.num_doc = null;
    state.params.prefix = '';
    state.params.date = moment().format('YYYY-MM-DD');
    state.params.contact_id = doc.contact_id;
    state.params.document_id = doc.id;
    state.params.observation = doc.observation;
    state.params.observation2 = doc.observation_two;
    state.params.city_id = doc.city;
    state.params.seller_id = doc.seller_id;
    state.params.id_correria = doc.id_correria;
    state.sellers = [doc.seller];
    state.params.affects_prefix_document = '';
    state.params.affects_number_document = '';
    state.params.affects_date_document = moment().format('YYYY-MM-DD');
    state.params.due_date = due_date;
    state.params.term_days = doc.term_days;
    state.params.files = doc.files;
    state.params.original_document = doc.original_document;
    state.params.template_id                    = doc.model_id

    state.params.documents_products = doc.documents_products;

    state.params.document_transactions = [];

    doc.accounting_transactions.map((el, index) => {

        el.tax_id = el.account ? el.account.tax_id : null
        el.projects_column_visible = el.account && el.account.manage_projects;
        el.contact_column_visible = el.account && el.account.manage_contact_balances;
        el.payment_column_visible = el.payment_column_visible == null ? el.account.manage_way_to_pay : el.payment_column_visible;
        el.base_value_column_visible = el.account && el.account.manage_base_value;
        el.manage_document = (el.account && el.account.manage_document_balances) || el.by_origin_document;
        el.manage_bank_document = el.account && el.account.manage_bank_document;
        el.commissionable_concept = el.account && el.account.commissionable_concept;
        el.manage_quota_balances = el.account && el.account.manage_quota_balances;
        el.validation_no_doc = el.validation_no_doc == null && el.account.manage_document_balances ? '2' : el.validation_no_doc;
        el.cost_center_column_visible = (el.account && el.account.cost_center_1) === 1 || (el.account && el.account.cost_center_2) === 1 || (el.account && el.account.cost_center_3 === 1);

        state.params.document_transactions.push({
            //datos que se muetran en la grilla
            order: index,
            payment_method: null,
            account_id: el.account_id,
            observation: el.observations,
            contact_id: el.contact_id,
            projects_id: el.projects_id,
            value: el.operation_value,
            debit_credit: el.transactions_type,
            base_value: el.base_value == null ? 0 : el.base_value,
            bank_document_number: el.bank_document_number,
            commissionable_concept_id: el.commissionable_concept_id,
            due_date: due_date,
            pay_day: contact.pay_days,
            quota_number: el.quota_number,
            center_cost :   el.center_cost,

            //datos para mostrar u ocultar columnas
            by_origin_document: el.account && el.account.manage_document_balances && el.affects_document_id != el.document_id && (state.edit_document || state.Watch_documument) && doc.vouchertype && doc.vouchertype.origin_document,

            //datos para cargar los selects
            account_select: el.account ? [el.account]: [],
            contact_select: [el.contact],
            account_code: el.account != null ? el.account.code : null,
            account_name: el.account != null ? el.account.name : null,

            //ids para grilla y para manejo en back(crear o actualizar)
            id_document_transactions: el.id,
            id: index,

            // verificar
            affects_document_id: el.affects_document_id === doc.id ? null : el.affects_document_id,
            documet_id: el.document_number,
            no_doc: '',
            affects_prefix_document: el.affects_prefix_document,
            crossing_number: el.crossing_consecutive,
            crossing_date: el.crossing_due_date_document,
            mode: state.origin_document && el.account && el.account.manage_document_balances ? 1 : 2,
            disabled_account_select: false,
            affects_prefix: '',
            affects_consecutive: '',
            tax_id: el.tax_id,
            projects_column_visible: el.projects_column_visible,
            contact_column_visible: el.contact_column_visible,
            payment_column_visible: el.payment_column_visible,
            base_value_column_visible: el.base_value_column_visible,
            manage_document: el.manage_document,
            manage_bank_document: el.manage_bank_document,
            commissionable_concept: el.commissionable_concept,
            manage_quota_balances: el.manage_quota_balances,
            validation_no_doc: el.validation_no_doc,
            cost_center_column_visible: el.cost_center_column_visible
        });
    });

    state.totals = {
        // Totales de los productos informativo
        total_quantity: doc.total_quantity,
        total_discount: doc.total_discount,
        total_vr_brut: doc.total_vr_brut,
        total_vr_iva: doc.total_vr_iva,
        total_: doc.total_,
        total_items: doc.total_items,
        total_inventory_cost_value: doc.total_inventory_cost_value,

        //totales documento
        total_value_brut: doc.total_value_brut,
        ret_fue_total: doc.ret_fue_total,
        ret_iva_total: doc.ret_iva_total,
        ret_ica_total: doc.ret_ica_total,
        total_value: doc.total_value
    };
    state.templates = state.params.template_id == null ? [] : state.templates;
    state.sellers = state.params.seller_id == null ? [] : state.sellers;

    state.loading_totals = false;
    state.edit_document = false;
}

/**
 * Establecer un valor para la variable edit_document.
 */
export function setEditDocument(state, edit_document) {
    state.edit_document = edit_document;
}

export function setloading_totals(state, loading_totals){
    state.loading_totals = loading_totals
}
export function setloading_accounting_document(state, loading_accounting_document){
    state.loading_accounting_document = loading_accounting_document
}
export function setloading_csv(state, loading_csv){
    state.loading_csv = loading_csv
}
export function settotal_difference(state, total_difference){
    state.total_difference = total_difference
}
export function setbase_value_column_visible(state, base_value_column_visible){
    state.base_value_column_visible = base_value_column_visible
}
export function setWatchDocumument(state, Watch_documument){
    state.Watch_documument = Watch_documument
}
export function setCancellationReasons(state, cancellation_reasons){
    state.cancellation_reasons = cancellation_reasons
}
export function clearParams(state){

    if (state.pdf_clear_params){
        state.selected_document = false;
        state.Watch_documument = false;
        state.edit_document = false;
        state.loading_totals = false
        state.show_pdf = false
        state.file_name = null


        state.document_files_new = [];
        state.document_files_delete = [];
        state.params.files = [];


        state.showInputs.center_cost = true

        let voucherType = state.voucherTypes.find(el => el.id === state.params.voucherType_id)
        if (voucherType){
            state.showInputs.seller = Boolean(voucherType.select_seller)
            state.showInputs.correrias = Boolean(voucherType.select_correreria)
        }

        state.showInputs.observation1 = true
        state.showInputs.observation2 = true
        state.showInputs.projects = true
        state.showInputs.cross_doc = true
        state.showInputs.cross_doc_date = true
        state.origin_document = false

        state.selected_document_title.id            = null
        state.selected_document_title.in_progress   = null

        // state.params.branchoffice_id                = null
        state.params.voucherType_id                 = null
        state.params.prefix                         = null
        state.params.num_doc                        = null
        state.params.date                           = null
        state.params.check_info                     = null

        let date = new Date()
        let year = date.toLocaleDateString('COT', {year:'numeric'}).replace(/\//g, '-')
        let day = date.toLocaleDateString('COT', {day:'2-digit'}).replace(/\//g, '-')
        let month = date.toLocaleDateString('COT', {month:'2-digit'}).replace(/\//g, '-')
        state.params.date = `${year}-${month}-${day}`

        state.params.original_document              = null
        state.params.template_id                    = null
        state.params.contact_id                     = null
        state.params.document_id                    = null
        state.params.observation                    = null
        state.params.city_id                        = null
        state.params.seller_id                      = null

        state.params.affects_number_document        = null
        state.params.affects_prefix_document        = null
        state.params.affects_date_document          = null
        state.params.term_days_crossing             = null
        state.params.crossing_due_date_document     = null
        state.params.due_date                       = null
        state.params.term_days                      = null
        state.params.documents_products=[]
        state.totals={},
            state.params.document_transactions =[]

        state.params.user                           = null
        state.params.user_accounting_modification   = null
        state.params.document_date                  = null
        state.params.accounting_date_last_modification= null

        state.params.document_transactions = [
            {
                id : 1,
                account_id : null,
                observation : '',
                contact_id : null,
                no_doc : null,
                value : 0,
                base_value : 0,
                order : 1,
                payment_method : null,
                projects_column_visible : null,
                contact_column_visible : null,
                cost_center_column_visible : null,
                account_select : [],
                contact_select : [],
                projects_id : null,
                affects_prefix: null,
                affects_consecutive: null,
                affects_document_id: null,
                mode: 1
            }
        ]

        state.total_debit = 0;
        state.total_credit = 0;
        state.total_difference = 0;


        state.templates = [];
        state.params.id_correria = null
    }else{
        state.show_pdf = false;
    }
}

export function setDocumentFile(state, data) {
    let extension = data.name.split(".");
    let file = {
        id: null,
        name: data.name,
        extension: extension[extension.length - 1],
        path: "",
        size: data.size,
        sent: false,
        document_id: state.params.document_id
    };

    state.params.files.push(file);

    state.document_files_new.push(data);
}

export function deleteDocumentFile(state, data) {
    if (data.id) {
        let key_file = state.params.files.findIndex(
            f => f.id === data.id
        );
        state.params.files.splice(key_file, 1);
        state.document_files_delete.push(data);
    } else {
        let key_file = state.params.files.findIndex(
            f => f.size === data.size && f.name === data.name
        );
        state.params.files.splice(key_file, 1);

        let key_file_new = state.document_files_new.findIndex(
            f => f.size === data.size && f.name === data.name
        );
        state.document_files_new.splice(key_file_new, 1);
    }
}

export function setFiles(state, files){
    let file;
    files.map(el => {
        file = state.params.files.find(f => f.name == el.name && f.size == el.size);
        if (file) {
            file.path = el.path
        }
    })
}

/**
 * Establecer un valor para el atributo show de la variable modal_alert.
 */
export function setShowToModalAlert(state, show) {
    state.modal_alert.show = show;
}

/**
 * Establecer un valor para la variable old_document.
 */
export function setOldDocument(state, old_document) {
    state.old_document = old_document;
}

export function setFilesSearchDocument(state, files_search_document){
    state.files_search_document = files_search_document
}

export function setAudit(state, auditDocuments) {
    state.auditDocuments = auditDocuments;
}

export function setContactsAudit(state, contacts) {
    state.paramsDocument = contacts;
}

export function setValidateFirmDateAccount(state, validate_firm_date_account){
    state.validate_firm_date_account = validate_firm_date_account
}


export function setPdfDocument(state, document){
    state.pdf_document_name = document.vouchertype.name_voucher_type+' No.' + document.consecutive + '.pdf'
}

export function setSubscriber(state, subscriber) {
    state.subscriber = subscriber
  }

/**
 * Establecer un valor para la variable expiration.
 */
export function setExpiration(state, expiration) {
    state.expiration = expiration;
}

export function validateFieldsVoucherType(state, vouherType) {
    state.showInputs.seller = Boolean(vouherType.select_seller)
    state.showInputs.correrias = Boolean(vouherType.select_correreria)
}
export function setCorrerias(state, correrias) {
    state.correrias = correrias;
}

/**
 * Establecer un valor para la variable params.
 */
export function setParams(state, params) {
    state.params = params;
}

/**
 * Establecer un valor para la variable balances_by_contacts.
 */
export function setBalancesByContacts(state, balances_by_contacts) {
    state.balances_by_contacts = balances_by_contacts;
}

export function setLoadingCloneDocument(state, loading_clone_document) {
    state.loading_clone_document = loading_clone_document;
}


// WEBPACK FOOTER //
// ./src/modules/various-vouchers/mutations.js